module.exports = __webpack_public_path__ + "img/icebreaker.6338e981.jpg";